import { UserAvatarCard } from '@equip.health/ui';

const TOP_LEVEL_ID = 'notification-avatar';

interface NotificationAvatarProps {
  patientName?: string;
}

const NotificationAvatar = ({ patientName }: NotificationAvatarProps) => (
  <UserAvatarCard
    avatarOnly
    avatarSize="large"
    id={`${TOP_LEVEL_ID}`}
    primaryText={[patientName]}
  />
);

export default NotificationAvatar;
